import * as React from 'react';
import './print.css';

type Row = { day: any; workout?: any; exercises?: any[] };
export default function ProgramWeekPrint(props: {
  clientName?: string;
  programName?: string;
  weekNumber: number;
  rows: Row[];
  onClose?: () => void;
}) {
  const { clientName, programName, weekNumber, rows } = props;

  // No auto-print: this component renders in its own window/tab by the caller.

  return (
    <div className="print-root">
      <header className="print-header">
        <div>
          <div className="print-title">{programName || 'Program'}</div>
          <div className="print-sub">
            Client: {clientName || '—'} • Week {weekNumber}
          </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <div className="print-badge no-print" onClick={() => window.print()} style={{ cursor: 'pointer' }}>
            Print
          </div>
          <div className="print-badge">Program Week</div>
        </div>
      </header>

      <section className="print-section">
        {rows.map(({ day, workout, exercises }, i) => {
          const dow = new Date(day.date).toLocaleDateString(undefined, {
            weekday: 'short',
            month: 'short',
            day: 'numeric',
          });
          const isRest = String(day.type || '').toLowerCase() === 'rest';
          const title = day?.title || workout?.name || (isRest ? 'Rest' : 'Workout');
          const dur = (day as any)?.durationMin ?? (workout as any)?.durationMin;
          const modality = (workout as any)?.modality
            ? String((workout as any).modality)
                .charAt(0)
                .toUpperCase() + String((workout as any).modality).slice(1)
            : undefined;

          return (
            <div key={i} className="print-day">
              <div className="print-day-head">
                <div className="print-day-title">
                  <span className="print-dow">{dow}</span>
                  <span className="print-sep">•</span>
                  <span>{title}</span>
                  {modality && <span className="print-chip">{modality}</span>}
                  {dur ? <span className="print-meta">{dur}m</span> : null}
                </div>
              </div>
              {isRest ? (
                <div className="print-rest">Rest day</div>
              ) : (
                <table className="print-table">
                  <thead>
                    <tr>
                      <th style={{ width: '45%' }}>Exercise</th>
                      <th>Sets</th>
                      <th>Reps</th>
                      <th>Rest</th>
                      <th>Notes</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(exercises ?? []).map((e: any, idx: number) => (
                      <tr key={idx}>
                        <td>{e.name || e.title || 'Exercise'}</td>
                        <td>{e.sets ?? '—'}</td>
                        <td>{e.reps ?? e.effort ?? '—'}</td>
                        <td>{e.rest ?? '—'}</td>
                        <td>{e.notes ?? ''}</td>
                      </tr>
                    ))}
                    {(!exercises || exercises.length === 0) && (
                      <tr>
                        <td colSpan={5} className="print-empty">
                          No exercises defined
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              )}
            </div>
          );
        })}
      </section>
    </div>
  );
}
